<section class="assistant-results" [attr.aria-label]="i18n.t('auditAssistant.results.title')">
  <h3>{{ i18n.t('auditAssistant.results.title') }} ({{ results().audits.length }})</h3>
  @for (audit of results().audits; track audit.audit_id) {
    <article class="app-panel assistant-results__audit">
      <h4>{{ audit.name }}</h4>
      <div class="assistant-results__status">
        <span>{{ i18n.t('auditAssistant.results.definitionStatus') }}</span>
        <span class="app-status-chip"
          [class.app-status-chip--draft]="audit.status === 'draft'"
          [class.app-status-chip--active]="audit.status === 'active'"
          [class.app-status-chip--scheduled]="audit.status === 'scheduled'"
          [class.app-status-chip--archived]="audit.status === 'archived'"
          [class.app-status-chip--in-progress]="audit.status === 'processing'"
          [class.app-status-chip--overdue]="audit.status === 'failed'">{{ i18n.t('auditList.status.' + audit.status) }}</span>
      </div>
      <p>{{ i18n.t('auditAssistant.results.active') }}: {{ i18n.t(audit.is_active ? 'auditAssistant.results.yes' : 'auditAssistant.results.no') }}</p>
      <ul class="assistant-results__groups">
        @for (group of audit.groups; track group.group_id) {
          <li>
            <strong>{{ group.name }}</strong>
            <p class="app-panel__meta">{{ group.checklist_title }} · {{ i18n.t('auditAssistant.results.version') }} {{ group.checklist_version }}</p>
            <ul>
              @for (question of group.questions; track question.question_id) {
                <li>{{ question.title }}</li>
              }
            </ul>
          </li>
        }
      </ul>
      @for (location of audit.locations; track location.location_id + ':' + location.role_id) {
        <div class="assistant-results__execution">
          <h5>{{ location.location_name }} · {{ role(location.role) }}</h5>
          <dl>
            <dt>{{ i18n.t('auditAssistant.results.lastExecution') }}</dt>
            <dd>
              @if (location.last_execution; as last) {
                <time [attr.datetime]="last.completed_at">{{ dateTime(last.completed_at) }}</time>
                @if (last.completed_at_is_estimated) {
                  <span class="app-panel__meta"> ({{ i18n.t('auditAssistant.results.estimated') }})</span>
                }
              } @else { {{ i18n.t('auditAssistant.results.noLastExecution') }} }
            </dd>
            <dt>{{ i18n.t('auditAssistant.results.nextExecution') }}</dt>
            <dd>
              @if (location.next_execution; as next) {
                <time [attr.datetime]="next.planned_date">{{ date(next.planned_date) }}</time>
              } @else { {{ i18n.t('auditAssistant.results.noNextExecution') }} }
            </dd>
          </dl>
        </div>
      } @empty { <p class="app-panel__meta">{{ i18n.t('auditAssistant.results.noLocations') }}</p> }
    </article>
  } @empty {
    <p class="app-panel__meta">{{ i18n.t(results().search_status === 'catalog_empty' ? 'auditAssistant.results.emptyCatalog' : 'auditAssistant.results.noMatches') }}</p>
  }
  <div class="assistant-results__coverage">
    <h4>{{ i18n.t('auditAssistant.results.coverage') }}</h4>
    @if (!results().coverage.catalog_complete || !results().coverage.selected_questions_results_complete) {
      <p>{{ i18n.t('auditAssistant.results.partial') }}</p>
    }
    <p>{{ i18n.t('auditAssistant.results.matchedQuestions') }}: {{ results().coverage.selected_question_count }}</p>
    <details>
      <summary>{{ i18n.t('auditAssistant.results.verified') }} ({{ results().coverage.verified_groups.length }})</summary>
      <ul>@for (group of results().coverage.verified_groups; track group.id) { <li>{{ group.name }}</li> }</ul>
    </details>
    @if (results().coverage.unverified_groups.length) {
      <details open>
        <summary>{{ i18n.t('auditAssistant.results.unverified') }} ({{ results().coverage.unverified_groups.length }})</summary>
        <ul>@for (group of results().coverage.unverified_groups; track group.id) { <li>{{ group.name }}</li> }</ul>
      </details>
    }
    @if (results().coverage.partially_verified_groups.length) {
      <details open>
        <summary>{{ i18n.t('auditAssistant.results.partiallyVerified') }} ({{ results().coverage.partially_verified_groups.length }})</summary>
        <ul>@for (group of results().coverage.partially_verified_groups; track group.id) { <li>{{ group.name }}</li> }</ul>
      </details>
    }
    <p class="app-panel__meta">{{ i18n.t('auditAssistant.results.asOf') }}: <time [attr.datetime]="results().as_of">{{ dateTime(results().as_of) }}</time></p>
  </div>
</section>
